import React from 'react';
import { formatTime } from '../../utils/helpers';

const SessionTimer = ({ elapsedTime }) => {
  return (
    <div className="session-timer fixed">
      ⏱️{formatTime(elapsedTime)}
    </div>
  );
};

export default SessionTimer;
